export const SUPERADMIN = 'SUPERADMIN'